import { createAction } from "redux-actions";
import { LibraryCard, CardProperties, CardType } from "../../types/LibraryCard";

export const SET_BOOKS = 'SET_BOOKS';
export const PUSH_BOOKS = 'PUSH_BOOKS';
export const SET_BOOK_PROPERTIES = "SET_BOOK_PROPERTIES";
export const DELETE_BOOKS = 'DELETE_BOOKS';
export const REMOVE_HISTORY_ITEM = "REMOVE_HISTORY_ITEM";
export const EDIT_HISTORY_ITEM = "EDIT_HISTORY_ITEM";

export interface SetBookPropertiesPayload {
	properties: CardProperties;
	cardId: number;
	cardType?: CardType;
}

export interface RemoveHistoryPayload {
	cardId: number;
	historyId: number;
}

export interface EditHistoryItemPayload {
	cardId: number;
	historyId: number;
	start: string;
	end: string;
}

export const pushBooksAction = createAction<LibraryCard[]>(PUSH_BOOKS);
export const setBooksAction = createAction<LibraryCard[]>(SET_BOOKS);
export const setBookProperties = createAction<SetBookPropertiesPayload>(SET_BOOK_PROPERTIES);
export const deleteBookAction = createAction<number>(DELETE_BOOKS);
export const removeHistoryItem = createAction<RemoveHistoryPayload>(REMOVE_HISTORY_ITEM);
export const editHistoryItem = createAction<EditHistoryItemPayload>(EDIT_HISTORY_ITEM);